export default "__VITE_PUBLIC_ASSET__06ca57c5__"